module.exports = __webpack_public_path__ + "static/media/pin_odontoiatria_highlighted_old.5ba14ad2.png";